import React from 'react';
import { Space, Tag, Typography } from 'antd';
import { BankOutlined, HomeOutlined } from '@ant-design/icons';

const { Text } = Typography;

export interface BranchDisplayProps {
  branch?: {
    id: string;
    displayId: string;
    name: string;
    type?: string | null;
    isActive?: boolean;
  };
  showDisplayId?: boolean;
  showType?: boolean;
  showStatus?: boolean;
  size?: 'small' | 'default' | 'large';
  style?: React.CSSProperties;
}

/**
 * ブランチ（拠点）情報を統一的に表示するコンポーネント
 *
 * @example
 * // 基本的な使用
 * <BranchDisplay branch={branch} />
 *
 * @example
 * // 詳細情報表示
 * <BranchDisplay branch={branch} showDisplayId showType showStatus />
 */
export function BranchDisplay({
  branch,
  showDisplayId = true,
  showType = false,
  showStatus = false,
  size = 'default',
  style
}: BranchDisplayProps): JSX.Element | null {
  if (!branch) {
    return null;
  }

  const iconSize = size === 'small' ? 12 : size === 'large' ? 18 : 14;
  const fontSize = size === 'small' ? 12 : size === 'large' ? 16 : 14;
  const icon = branch.type === '本社' ? <HomeOutlined style={{ fontSize: iconSize }} /> : <BankOutlined style={{ fontSize: iconSize }} />;

  return (
    <Space size={8} style={style}>
      {icon}
      <Text style={{ fontSize }}>
        {showDisplayId && branch.displayId && `${branch.displayId} - `}
        {branch.name}
      </Text>
      {showType && branch.type && (
        <Tag color="blue" style={{ fontSize: size === 'small' ? 11 : 12, margin: 0 }}>
          {branch.type}
        </Tag>
      )}
      {showStatus && (
        <Tag color={branch.isActive ? 'green' : 'default'} style={{ fontSize: size === 'small' ? 11 : 12, margin: 0 }}>
          {branch.isActive ? '有効' : '無効'}
        </Tag>
      )}
    </Space>
  );
}
